var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as moment from 'moment';
import { BaseEntity, Default, Transform } from './base';
export var EtaStatus;
(function (EtaStatus) {
    EtaStatus["OnTime"] = "on-time";
    EtaStatus["RunningEarly"] = "running-early";
    EtaStatus["RunningLate"] = "running-late";
    EtaStatus["NotAvailable"] = "not-available";
})(EtaStatus || (EtaStatus = {}));
export var EtaStatusExplanation;
(function (EtaStatusExplanation) {
    EtaStatusExplanation["OnTime"] = "Things are currently looking good for the Yoshi truck to arrive to your vehicle within your requested window!";
    EtaStatusExplanation["RunningEarly"] = "We are projecting the Yoshi truck may arrive at your vehicle earlier than your requested window.";
    EtaStatusExplanation["RunningLate"] = "Our system is projecting the Yoshi truck may arrive at your vehicle later than your requested window. Please stay tuned as we attempt to remain schedule.";
    EtaStatusExplanation["NotAvailable"] = "Eta status is not available at this moment. Check back later.";
})(EtaStatusExplanation || (EtaStatusExplanation = {}));
const ɵ0 = value => moment(value, 'HH:mm').toDate(), ɵ1 = value => moment(value, 'HH:mm').toDate();
export class EtaModel extends BaseEntity {
    get displayString() {
        if (this.etaStart && this.etaEnd) {
            return `${moment(this.etaStart).format('h:mmA')}-${moment(this.etaEnd).format('h:mmA')}`;
        }
    }
}
__decorate([
    Default(null),
    Transform(ɵ0),
    __metadata("design:type", Date)
], EtaModel.prototype, "etaStart", void 0);
__decorate([
    Default(null),
    Transform(ɵ1),
    __metadata("design:type", Date)
], EtaModel.prototype, "etaEnd", void 0);
export { ɵ0, ɵ1 };
//# sourceMappingURL=eta.js.map


// WEBPACK FOOTER //
// ./src/models/eta.ts.pre-build-optimizer.js